import React, { useEffect, useState } from "react";
import styles from "./DashboardStats.module.scss";
import { API_ENDPOINTS, getAuthHeaders } from "../config/api";

function DashboardStats() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(`${API_ENDPOINTS.RESERVATIONS}/stats/dashboard`, {
        headers: getAuthHeaders(),
      });
      
      if (!response.ok) throw new Error("Échec du chargement des statistiques");
      
      const data = await response.json();
      setStats(data);
    } catch (err) {
      console.error(err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const formatCurrency = (amount, currency) => {
    const symbols = { TND: 'TND', EUR: '€', USD: '$' };
    return `${symbols[currency] || currency} ${amount.toFixed(2)}`;
  };

  if (loading) {
    return (
      <div className={styles.loading}>
        <div className={styles.spinner}></div>
        <p>Chargement des statistiques...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className={styles.error}>
        <p>Erreur de chargement : {error}</p>
        <button onClick={fetchStats} className={styles.refreshBtn}>Réessayer</button>
      </div>
    );
  }

  if (!stats) return null;

  const totalRevenue = stats.totalRevenue && stats.totalRevenue.length > 0 
    ? stats.totalRevenue[0].total 
    : 0;

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h2>Vue d'ensemble</h2>
        <button onClick={fetchStats} className={styles.refreshBtn}>
          Actualiser
        </button>
      </div>
      
      <div className={styles.statsGrid}>
        {/* Status Cards */}
        <div className={`${styles.statCard} ${styles.pending}`}>
          <div className={styles.content}>
            <p className={styles.label}>Demandes en attente</p>
            <h3 className={styles.value}>{stats.pending}</h3>
          </div>
        </div>

        <div className={`${styles.statCard} ${styles.quoted}`}>
          <div className={styles.content}>
            <p className={styles.label}>Devis envoyés</p>
            <h3 className={styles.value}>{stats.quoted}</h3>
          </div>
        </div>

        <div className={`${styles.statCard} ${styles.confirmed}`}>
          <div className={styles.content}>
            <p className={styles.label}>Confirmées</p>
            <h3 className={styles.value}>{stats.confirmed}</h3>
          </div>
        </div>

        <div className={`${styles.statCard} ${styles.checkedIn}`}>
          <div className={styles.content}>
            <p className={styles.label}>Clients présents</p>
            <h3 className={styles.value}>{stats.checkedIn}</h3>
          </div>
        </div>

        <div className={`${styles.statCard} ${styles.todayCheckIns}`}>
          <div className={styles.content}>
            <p className={styles.label}>Arrivées aujourd'hui</p>
            <h3 className={styles.value}>{stats.todayCheckIns}</h3>
          </div>
        </div>

        <div className={`${styles.statCard} ${styles.todayCheckOuts}`}>
          <div className={styles.content}>
            <p className={styles.label}>Départs aujourd'hui</p>
            <h3 className={styles.value}>{stats.todayCheckOuts}</h3>
          </div>
        </div>

        <div className={`${styles.statCard} ${styles.upcomingWeek}`}>
          <div className={styles.content}>
            <p className={styles.label}>Cette semaine</p>
            <h3 className={styles.value}>{stats.upcomingWeek}</h3>
          </div>
        </div>

        <div className={`${styles.statCard} ${styles.upcomingMonth}`}>
          <div className={styles.content}>
            <p className={styles.label}>Ce mois-ci</p>
            <h3 className={styles.value}>{stats.upcomingMonth}</h3>
          </div>
        </div>
      </div>

      {/* Revenue Section */}
      <div className={styles.revenueSection}>
        <h3>Revenus par devise</h3>
        {stats.revenueByCurrency && stats.revenueByCurrency.length > 0 ? (
          <div className={styles.revenueCards}>
            {stats.revenueByCurrency.map((rev) => (
              <div key={rev._id} className={styles.revenueCard}>
                <p className={styles.currency}>{rev._id}</p>
                <h4 className={styles.amount}>{formatCurrency(rev.total, rev._id)}</h4>
              </div>
            ))}
          </div>
        ) : (
          <div className={styles.noRevenue}>
            <p>Aucun revenu enregistré</p>
          </div>
        )}
      </div>

      <div className={styles.footer}>
        <p className={styles.timestamp}>
          Dernière mise à jour : {new Date().toLocaleString('fr-FR')}
        </p>
      </div>
    </div>
  );
}

export default DashboardStats;
